import React from 'react';
import DV    from 'ts-data-validator';

function ImageSlide({
  slide,
  onClick,
}) {
  const image = DV.isString(slide.image) ? slide.image : (slide.image || [])[0];
  const ext   = image.substring(image.lastIndexOf('.') + 1, image.length);

  /**
   * @param {number} size
   * @param {string} [extension='png']
   *
   * @returns {string}
   */
  const getSrc = (size, extension = 'png') => {
    return `${image}${(ext === 'png' || ext === 'svg' || ext === 'gif') ? '' : `.${extension}?w=${size}&default=horizontal&t=${BUILD_TIME}`}`;
  };

  const src = getSrc(768);

  return (
    <picture onClick={onClick}>
      {!(ext === 'svg' || ext === 'gif') && (
        <>
          <source srcSet={getSrc(768, 'webp')} type={'image/webp'} />
          <source srcSet={src} type={'image/png'} />
        </>
      )}
      <img
        src={getSrc(768)}
        srcSet={`${src} 320w`}
        sizes={`320px`}
        alt={slide.alt || slide.title || ''}
      />
    </picture>
  );
}

export default React.memo(ImageSlide);